export default __webpack_public_path__ + "static/media/venture_service6.3b5cbc1b.jpg";